import {
  Grid,
  LinearProgress,
  Theme,
  Link,
  Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { reduxForm } from 'redux-form'
import SubmitFormButton from '../../../components/Buttons/SubmitFormButton'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxFormField } from '../../../components/FormInput/ReduxWrappers'
import { MuiClasses } from '../../../types'
import {
  validateEmail,
  validatePassword,
  passwordsMatch,
  noSpacesPhoneNum,
  required,
  noSpaceValue,
  validatePhoneNumber
} from '../../../utils/validation/forms'

const styles = ({ spacing }: Theme) => ({
  autocomplete: {
    marginTop: spacing(2)
  },
  link: {
    textDecoration: 'underline',
    marginTop: '0.5rem'
  }
})

type Props = {
  classes: MuiClasses
  handleSubmit: (arg: any) => any
  submitting: boolean
  error: string
  signup: (arg: any) => any
  t: (arg: any) => any
}

const SignupForm = ({
  classes,
  handleSubmit,
  submitting,
  signup,
  error,
  t
}: Props) => (
  <form onSubmit={handleSubmit(signup)}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <ReduxFormField
          autoComplete='username'
          name='email'
          label={t('person.email')}
          validate={[required, noSpaceValue, validateEmail]}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <ReduxFormField
          name='name'
          label={t('person.fullName')}
          validate={[required]}
        />
      </Grid>
      <Grid item xs={12}>
        <ReduxFormField
          autoComplete='tel'
          name='phoneNumber'
          label={t('person.phoneNum')}
          helperText={t('editProfile.phoneHelperText')}
          validate={[required, noSpacesPhoneNum, validatePhoneNumber]}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <ReduxFormField
          autoComplete='new-password'
          name='password'
          label={t('person.password')}
          type='password'
          helperText={t('changePw.helperText')}
          validate={[required, noSpaceValue, validatePassword]}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <ReduxFormField
          autoComplete='off'
          name='confirmPassword'
          label={t('signup.confirmPw')}
          type='password'
          validate={[required, validatePassword, passwordsMatch]}
          required
        />
      </Grid>
      {submitting && <LinearProgress />}
      <ErrorMessage error={error} />
      <SubmitFormButton
        submitting={submitting}
        label='signup.signup'
        fullWidth
      />

      <Link
        href='https://fiksuvuokraus.fi/tietosuojaseloste'
        target='_blank'
        rel='noopener'
        className={classes.link}
      >
        <Typography>{t('general.agreeToPolicy')}</Typography>
      </Link>
    </Grid>
  </form>
)

export default reduxForm({
  form: 'SignupForm'
})(withStyles(styles)(withTranslation()(SignupForm as any)) as any) as any
